var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.353,
    height: 26.548,
    viewBox: "0 0 27.353 26.548",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_382",
    "data-name": "Group 382",
    transform: "translate(-3091 -817.202)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1512",
    "data-name": "Path 1512",
    d: "M5,12.03a4.928,4.928,0,0,1,5-4.853A4.928,4.928,0,0,1,5,2.324,4.928,4.928,0,0,1,0,7.177,4.928,4.928,0,0,1,5,12.03",
    transform: "translate(3108.353 814.878)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1511",
    "data-name": "Path 1511",
    d: "M12.277,26.156A12.1,12.1,0,0,1,24.554,14.24,12.1,12.1,0,0,1,12.277,2.324,12.1,12.1,0,0,1,0,14.24,12.1,12.1,0,0,1,12.277,26.156",
    transform: "translate(3091 817.594)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.71b2302102e2303a3c15289e24788dbd.svg";
export { ForwardRef as ReactComponent };